var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'menu-tip-wrap':true}},[_c('div',{staticClass:"triangle-bg",style:(_vm.triangleStyle)}),_c('div',{staticClass:"tip-msg",style:(_vm.msgStyle)},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }